<template>
    <div class="locale-changer">
        <div class="row align-items-center">
            <div class="col text-right">
                <span class="material-icons">language</span>
            </div>
          <div class="col-auto">
                <div class="btn-group btn-group-sm m-0" role="group">
                    <button v-if="!lang.hidden" type="button" class="btn m-0" :class="{'btn-primary btn-raised': $i18n.locale==lang.key}"
                            @click="changeLanguage(lang.key)"
                            v-for="(lang, i) in langs">
                            <span class="flag-icon flag-icon" :class="`flag-icon-${lang.icon}`"></span>
                            {{ lang.key }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LocaleChanger',
        data () {
            return {
              langs: [
                  { key: 'en',icon: 'gb', hidden: false },
                  { key: 'de', icon: 'de', hidden: false },
                  { key: 'de.developer', icon: 'de', hidden: true }
              ]}
        },
        mounted() {
          this.$i18n.locale = this.$store.state.locale.language
        },
        methods: {
          changeLanguage: function (langkey) {
            this.$i18n.locale = langkey
            this.$store.commit('setLocaleLanguage',langkey)
          }
        }
    }
</script>

<style lang="scss" scoped>
    span.flag-icon {
      height: 10px;
      line-height: 10px;
    }

    span.material-icons {
        margin-top: 5px;
        font-size: 1em;
    }
</style>
